module.exports = __webpack_public_path__ + "static/media/COS_HANDIPHARM_MAD.b38d4583.jpg";